/**
* @file 战队-比赛成绩
* @author 余凯
*/

import React from 'react'
import { Table, Tabs, Modal, Form, Button, Input, DatePicker, Drawer } from 'antd'
import { connect } from 'react-redux'
// import moment from 'moment';

import './index.less'
import 'moment/locale/zh-cn';
import Actions from '@/apis/team'
// moment.locale('zh-cn');
const { RangePicker } = DatePicker;
const { TabPane } = Tabs

const PAGE_SIZE = 10
@Form.create()
@connect(
  state => state.teamReducer,
)
class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userMatchInstId: null,
      userList: [],
      userTotal: 0,
      teamTotal: 0,
      teamList: [],
      visible: false,
      scorePage: 1,
      modalTitle: '',
      modalTime: '',
      teamScoreList: [],
      teamScoreTotal: 0,
      userScoreList: [],
      userScoreTotal: 0,
      paramsSorter: null,
      matchInstId: null,
      drawerList: [],
      drawerVisible: false,
      drawerTitle: '',
      teamCurrent: 1

    }
  }

  columns = () => [
    {
      title: '比赛名称',
      dataIndex: 'match_name',
    },
    {
      title: '比赛开始时间',
      dataIndex: 'create_time',
    },
    {
      title: '比赛结束时间',
      dataIndex: 'end_time',
    },
    {
      title: '详情',
      align: 'center',
      render: (action, record) => (
        <Button
          onClick={() => this.handleShowDetail(record)}
          type="primary"
          shape="round"
          size="small">
          查看
        </Button>
      )
    }
  ]

  teamScorecolumns = () => [
    {
      title: '排名',
      dataIndex: 'match_rank',
    },
    {
      title: '战队名称',
      dataIndex: 'team_name',
    },
    {
      title: '参赛人数',
      dataIndex: 'join_user',
    },
    {
      title: '总积分',
      dataIndex: 'team_score',
      sorter: (a, b) => null,
    },
    {
      title: '平均分',
      dataIndex: 'average',
      sorter: (a, b) => null,
    },
    {
      title: '详情',
      align: 'center',
      render: (action, record) => (
        <Button
          onClick={() => this.handleShowTeamDetail(record)}
          type="primary"
          shape="round"
          size="small">
          查看
        </Button>
      )
    }
  ]

  teamUsercolumns = () => [
    {
      title: '排名',
      dataIndex: 'match_rank',
    },
    {
      title: 'ID',
      dataIndex: 'user_id',
    },
    {
      title: '昵称',
      dataIndex: 'nick_name',
    },
    {
      title: '所属战队',
      dataIndex: 'team_name',
    },
    {
      title: '比赛分数',
      dataIndex: 'game_score',
    },
  ]

  drawerColumns = () => [
    {
      title: '排名',
      dataIndex: 'match_rank',
    },
    {
      title: '昵称',
      dataIndex: 'nick_name',
    },
    {
      title: '比赛积分',
      dataIndex: 'game_score',
    },
  ]

  componentDidMount() {
    this.getUserGame()
    this.getTeamGame()
  }

  showModal = (page, id) => {
  };

  handleShowDetail = (item) => {
    this.setState({
      userMatchInstId: item.match_inst_id,
      visible: true,
      modalTitle: item.match_name,
      modalTime: item.create_time + ' - ' + item.end_time
    }, () => {
      this.getUserScore(1, item.match_inst_id)
      this.getTeamScore(1, item.match_inst_id)
    });
  }

  // 显示比赛的战队详情
  handleShowTeamDetail = async item => {
    const params = {
      game_team_id: item.game_team_id,
      game_id: this.props.game,
      match_inst_id: this.state.matchInstId
    }
    this.setState({
      drawerVisible: true,
      drawerTitle: item.team_name
    })
    const res = await Actions.getScoreDetail(params, 'drawer')
    if (res.code == 200) {
      this.setState({
        drawerList: res.data
      })
    }
  }

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleCloseDrawer = e => {
    this.setState({
      drawerVisible: false,
      // drawerList: []
    })
  };

  // 我的比赛记录
  getUserGame = async (page = 1) => {
    const params = {
      game_id: this.props.game,
      page_index: page,
      page_size: PAGE_SIZE,
      type: 1
    }
    const res = await Actions.getTeamGame(params)
    if (res.code == 200) {
      this.setState({
        userTotal: res.data.totalNumber,
        userList: res.data.list
      })
    }
  }

  // 战队比赛记录
  getTeamGame = async (page = 1) => {
    const params = {
      game_id: this.props.game,
      page_index: page,
      page_size: PAGE_SIZE,
      type: 2
    }
    const { startTime, endTime, matchName } = this.state
    if (startTime) params.start_time = startTime
    if (endTime) params.end_time = endTime
    if (matchName) params.match_name = matchName
    const res = await Actions.getTeamGame(params)
    if (res.code == 200) {
      this.setState({
        teamTotal: res.data.totalNumber,
        teamList: res.data.list,
        teamCurrent: page
      })
    }
  }

  // 战队积分榜
  getTeamScore = async (page = 1, id = this.state.matchInstId, sort) => {
    const params = {
      game_id: this.props.game,
      page_index: page,
      page_size: PAGE_SIZE,
      match_inst_id: this.state.userMatchInstId,
      // match_sort_type: sort
    }
    if (sort) params.match_sort_type = sort
    const res = await Actions.getTeamScore(params)
    if (res.code == 200) {
      this.setState({
        teamScoreTotal: res.data.totalNumber,
        teamScoreList: res.data.list,
        matchInstId: id
      })
    }
  }

  // 个人积分榜
  getUserScore = async (page = 1) => {
    const params = {
      game_id: this.props.game,
      page_index: page,
      page_size: PAGE_SIZE,
      match_inst_id: this.state.userMatchInstId,
    }
    const res = await Actions.getUserScore(params)
    if (res.code == 200) {
      this.setState({
        userScoreTotal: res.data.totalNumber,
        userScoreList: res.data.list
      })
    }
  }

  handleChangeTable = (pagination, filters, sorter, extra) => {
    const dictObj = {
      team_score: 1,
      average: 2,
    }
    this.setState({
      paramsSorter: sorter.order == 'descend' ? dictObj[sorter.field] : null,
    }, () => {
      this.getTeamScore(pagination.current, this.state.matchInstId, this.state.paramsSorter)
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const startTime = values.date && values.date.length ? values.date[0].format('YYYY-MM-DD') : null
        const endTime = values.date && values.date.length ? values.date[1].format('YYYY-MM-DD') : null
        this.setState({
          startTime,
          endTime,
          matchName: values.matchName
        }, () => {
          this.getTeamGame()
        })
        // console.log('Received values of form: ', values, startDate, endDate);
      }
    });
  };

  render() {
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { userList, teamList, teamCurrent, userTotal, modalTitle, modalTime, teamScoreList, teamScoreTotal, userScoreList, userScoreTotal, scoreList,
      drawerVisible, drawerTitle, drawerList, teamTotal } = this.state
    return (
      <div className="team_results">

        <Tabs animated type="card">
          <TabPane tab="我的比赛" key="1">
            <Table
              bordered
              title={() => `我总共参加比赛${userTotal}次`}
              size="small"
              locale={{
                emptyText: '暂无数据'
              }}
              columns={this.columns()}
              dataSource={userList}
              pagination={{ pageSize: PAGE_SIZE, total: userTotal, onChange: this.getUserGame }}
            // scroll={{"y": 240}}
            />
          </TabPane>
          <TabPane tab="全部比赛" key="2">
            <Form layout="inline" onSubmit={this.handleSubmit} style={{ marginBottom: '10px' }}>
              <Form.Item label="比赛名称">
                {getFieldDecorator('matchName')(
                  <Input placeholder="比赛名称" />,
                )}
              </Form.Item>
              <Form.Item label="比赛日期">
                {getFieldDecorator('date')(<RangePicker
                  placeholder={['开始日期', '结束日期']}

                />)}
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" >
                  搜索
                </Button>
              </Form.Item>
            </Form>
            <Table
              bordered
              // title={() => '成绩'}
              size="small"
              columns={this.columns()}
              dataSource={teamList}
              pagination={{ pageSize: PAGE_SIZE, total: teamTotal, current: teamCurrent, onChange: this.getTeamGame }}
            // scroll={{"y": 240}}
            />
          </TabPane>
        </Tabs>

        <Modal
          width="800px"
          title={modalTitle}
          visible={this.state.visible}
          maskClosable={false}
          destroyOnClose
          footer={null}
          // onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <p>
            比赛时间：
            {modalTime}
          </p>
          <Tabs defaultActiveKey="1" >
            <TabPane tab="战队积分榜" key="1">
              <Table
                bordered
                // title={() => '成绩'}
                size="small"
                onChange={this.handleChangeTable}
                columns={this.teamScorecolumns()}
                sortDirections={['descend']}
                dataSource={teamScoreList}
                pagination={{ pageSize: PAGE_SIZE, total: teamScoreTotal }}
              // scroll={{"y": 240}}
              />
            </TabPane>
            <TabPane tab="个人积分榜" key="2">
              <Table
                bordered
                // title={() => '成绩'}
                size="small"
                columns={this.teamUsercolumns()}
                dataSource={userScoreList}
                pagination={{ pageSize: PAGE_SIZE, total: userScoreTotal, onChange: this.getUserScore }}
              // scroll={{"y": 240}}
              />
            </TabPane>

          </Tabs>
        </Modal>

        <Drawer
          title={drawerTitle}
          placement="right"
          closable={false}
          onClose={this.handleCloseDrawer}
          visible={drawerVisible}
        >
          <div
            id="drawer">
            <Table
              bordered
              // title={() => '成绩'}
              size="small"
              columns={this.drawerColumns()}
              dataSource={drawerList}
              pagination={false}
            // scroll={{"y": 240}}
            />
          </div>
        </Drawer>
      </div>
    );
  }
}

export default Results;
